<template>
    <!-- Page Header -->
    <div class="mb-8 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
      <div class="flex items-center gap-4">
        <div class="w-12 h-12 bg-gradient-to-br from-orange-500 to-orange-700 rounded-2xl
                    flex items-center justify-center shadow-lg shadow-orange-500/30">
          <svg class="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"/>
          </svg>
        </div>
        <div>
          <h1 class="text-2xl font-bold text-slate-900">Gallery</h1>
          <p class="text-sm text-slate-500 mt-0.5">Manage customer photo gallery</p>
        </div>
      </div>

      <router-link
        :to="{ name: 'app.galleries.create' }"
        class="inline-flex items-center gap-2 px-4 py-2.5 bg-gradient-to-r from-orange-500 to-orange-600
               hover:from-orange-600 hover:to-orange-700 text-white text-sm font-semibold rounded-xl
               shadow-md shadow-orange-500/25 transition-all duration-200 hover:shadow-lg hover:-translate-y-0.5"
      >
        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"/>
        </svg>
        Add New Image
      </router-link>
    </div>

    <GalleryTable />
</template>

<script setup>
import GalleryTable from "@/pages/Admin/Gallery/GalleryTable.vue";
</script>
